<!-- 客户列表 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <customerDataAction v-if="showStatus" ref="customerDataAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></customerDataAction>
        </el-drawer>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>

            <div class="page_content_top_line">
                <vSearch @searchData="searchData" @openSearchs="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
                </vSearch>
            </div>
        </div>

        <div class="page_content_center">
            <div class="left" :style="{height: tableHeight+'px'}" v-if="isMenu">
                <el-menu :default-active="activeMenu" :key="'menu-' + menuList.length" class="el-menu-vertical-demo" @select="handleMenuSelect">
                    <el-menu-item index="all">
                        <i class="el-icon-menu"></i>
                        <span slot="title">全部</span>
                    </el-menu-item>
                    <el-menu-item v-for="item in menuList" :key="item.codeId" :index="String(item.codeId)">
                        <i class="el-icon-document"></i>
                        <span slot="title">{{ item.codeType }}</span>
                    </el-menu-item>
                </el-menu>
            </div>
            <div class="right" :class="{ 'right-full': !isMenu }">
                <el-table @sort-change="sortChange" v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row
                          size="mini">
                    <el-table-column label="选择操作" align="center" width="80">
                        <template slot-scope="scope">
                            <el-radio v-model="selectedDataIndex" :label="scope.row.index" border size="mini">
                                <i class="el-icon-thumb"></i>
                            </el-radio>
                        </template>
                    </el-table-column>
                    <!-- 主表单 -->
                    <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                        <el-table-column v-if="tableValye.isShow == 1" align="center" :sortable="tableValye.isSort == 1 ? 'custom' : false" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField"
                                         show-overflow-tooltip :min-width="tableValye.fieldWeight">
                            <template slot-scope="scope">
                                <span v-if="tableValye.fieldType == 'date'">
                                    <span v-if="scope.row[tableValye.entityField]">
                                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                    </span>
                                </span>
                                <span v-else-if="tableValye.fieldType == 'formatter'">
                                    <span v-for="(item, index) in JSON.parse(tableValye.formatterContent)" :key="index">
                                        <el-tag size="mini" v-if="item.key == scope.row[tableValye.entityField]">{{ item.value
                               }}</el-tag>
                                    </span>
                                </span>
                                <span v-else-if="tableValye.isRift == 1">
                                    <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField] }}</a>
                                </span>

                                <!-- 成立日期 -->
                                <span v-else>{{ scope.row[tableValye.entityField] }}</span>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
            </div>
        </div>

        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

        </div>
        <el-dialog v-if="statusFlag" title="修改状态" :visible.sync="statusFlag" append-to-body top="20%" width="600px">
            <el-form @submit.native.prevent size="mini" :model="statusSendData" ref="statusSendData" label-width="100px">
                <el-form-item label="状态" prop="cmState" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                    <el-select v-model="statusSendData.cmState" size="mini" clearable>
                        <el-option label="停用" :value="0"></el-option>
                        <el-option label="正常" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="cmRemark">
                    <el-input v-model.trim="statusSendData.cmRemark" type="textarea" size="mini" clearable :maxlength="$store.state.inputLength"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="statusFlag = false">取 消</el-button>
                <el-button v-if="actionDataActionType == 17" type="primary" @click="setStatusDataAction1('statusSendData')">确定</el-button>
                <el-button v-else type="primary" @click="setStatusDataAction('statusSendData')">确定</el-button>
            </div>
        </el-dialog>
        <!-- 自定义设计 -->
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <customDesign ref="customDesign"></customDesign>
        <el-dialog title="维护开票信息" :visible.sync="invoiceFlag" width="400px">
            <el-form @submit.native.prevent size="mini" :model="invoiceObj" ref="invoiceObj" label-width="100px">
                <el-form-item label="推送方式" prop="pushMethod" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                    <el-radio-group class="input" v-model="invoiceObj.pushMethod" size="medium">
                        <el-radio-button :label="0">不推送</el-radio-button>
                        <el-radio-button :label="1">短信</el-radio-button>
                        <el-radio-button :label="2">邮箱</el-radio-button>
                        <el-radio-button :label="3">全部</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="invoiceObj.pushMethod == 3 || invoiceObj.pushMethod == 1" label="推送手机号" prop="pushPhone" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                    <el-input v-model.trim="invoiceObj.pushPhone" type="text" size="mini" clearable></el-input>
                </el-form-item>
                <el-form-item v-if="invoiceObj.pushMethod == 3 || invoiceObj.pushMethod == 2" label="推送邮箱" prop="pushEmail" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                    <el-input v-model.trim="invoiceObj.pushEmail" type="text" size="mini" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="invoiceFlag = false">取 消</el-button>
                <el-button type="primary" @click="invoiceClick('invoiceObj')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../byComponents/SearchScheme.vue";
import customerDataAction from "@/components/customerDataAction";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        customerDataAction
    },
    data() {
        //这里存放数据
        return {
            ormId: "",
            requesUrl: '',
            tableHeight: 0,
            getRequestData: {

            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],
            pageShowData: [],
            selectedDataIndex: 0,
            imgUrl: "", //图片显示根路径
            showStatus: false,
            actionData: {},
            statusFlag: false,
            statusSendData: {
                cmId: '', //	客户ID
                cmRemark: '', //	备注
                cmState: '', //	客户状态
            },
            DialogVisible: false,
            parentSearchData: {},
            seTitle: "",
            seWidth: "",
            actionDataActionType: '',
            //-------------------维护开票信息
            invoiceFlag: false,
            invoiceObj: {
                pushMethod: 0,
                pushPhone: "",
                pushEmail: "",
            },
            menuList: [],
            activeMenu: "all",
            isMenu: false,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        sortChange(column) {
            this.returnData.list = this.$common.sortChange(column, this.returnData.list, this.pageShowData.jurTableVo.jurconfigtable, 'entityField')
        },
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = sField;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        //检索带回数据
        changeInputModel(val) {
            console.log(val)
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val);
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        // 子组件触发
        drawerCancel(commitData) {
            this.showStatus = false;
            commitData && this.getDataList();
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页
                var isPenetrate = true;
                // 设置缓存 存入点击单号
                this.resetSetItem("penetrateOrderId", orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage(
                    {
                        //向窗口发送MessageEvent消息
                        cmd: "returnFormJson",
                        params: {
                            isPenetrate,
                        }, //参数
                    },
                    "*"
                );
            }
        },
        //图片地址转换
        pictureShow(data) {
            var imgList = [];
            data.forEach((item) => {
                imgList.push(this.imgUrl + "/" + item.fileUrl);
            });
            return imgList;
        },
        isShowData(name, value) {
            this.sendDataInfo[name] = value;
        },
        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId],
            });
            if (responseData.status == 200) {
                this.getButtonList();
                this.pageShowData = responseData.result;
                this.formDataList = this.pageShowData.jurFormVoList;
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                await this.getMenuData()
                this.getDataList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 左侧菜单切换
        handleMenuSelect(codeId) {
            this.activeMenu = String(codeId)
            if (codeId === 'all') {
                this.$set(this.getRequestData, 'codeType', '')
            } else {
                const menuItem = this.menuList.find(item => String(item.codeId) === String(codeId))
                if (!menuItem) return
                this.$set(this.getRequestData, 'codeType', menuItem.codeType)
            }
            this.getRequestData.page = 1
            this.getDataList()
        },
        clear(val) {
            if (val) {
                var arr = val.split(",")
                arr.forEach(item => {
                    this.$set(this.getRequestData, item, "")
                })
            }
        },
        // 动作集合
        actionSet(actionData) {
            console.log(actionData.actionType, 'actionData.actionType');
            this.actionDataActionType = ''
            var formDataList = this.formDataList;
            switch (actionData.actionType) {
                case 0:
                    this.showStatus = true;
                    this.actionData = {
                        cate: 0,
                        formData: formDataList,
                        oldData: "",
                        orderId: "",
                        printSouce: "",
                        printJurId: "",
                        type: "",
                    };
                    break;
                case 1:
                    var olddataInfo = JSON.parse(JSON.stringify(this.returnData.list[this.selectedDataIndex]));
                    if (!olddataInfo) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    let data
                    this.$http.queryCusmasterInfo({
                        ids: [olddataInfo.cmId]
                    }).then(res => {
                        if (res.status == 200) {
                            data = res.result
                            this.showStatus = true;
                            this.actionData = {
                                cate: 1,
                                formData: formDataList,
                                oldData: data,
                                orderId: data.cmId,
                                printSouce: "",
                                printJurId: "",
                                type: "",
                            };
                        }
                    })
                    break;
                case 2:
                    this.delDataAction();
                    break;
                case 3:
                    this.copyDataAction();
                    break;
                case 6:
                    this.exportMainInfo()
                    break;
                case 7:
                    this.exportLicenceInfo()
                    break;
                case 8:
                    if (this.returnData.list.length <= 0) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    }
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    if (!dataInfo) {
                        this.$message({
                            message: "请先选择您要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.$prompt('输入外部编码', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputPattern: /^.+$/,
                        inputErrorMessage: '请输入外部编码'
                    }).then(async ({ value }) => {
                        const res = await this.$http.cusmasterbindUnitNum({
                            cmId: dataInfo.cmId,
                            unitNum: value
                        })
                        if (res.status == 200) {
                            this.$message({
                                message: "操作成功",
                                type: "success",
                            });
                            this.getDataList()
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    }).catch(() => {
                    });
                    break;
                case 9:
                    if (this.returnData.list.length <= 0) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    }
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    if (!dataInfo) {
                        this.$message({
                            message: "请先选择您要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    for (const key in this.invoiceObj) {
                        if (dataInfo[key] != undefined && dataInfo[key] != null && dataInfo[key] !== "") {
                            this.invoiceObj[key] = dataInfo[key];
                        }
                    }
                    this.invoiceFlag = true
                    break;
                case 10:
                    if (this.returnData.list.length <= 0) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    }
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    if (!dataInfo) {
                        this.$message({
                            message: "请先选择您要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.$prompt('输入店铺编码', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputPattern: /^.+$/,
                        inputType: "textarea",
                        inputValue: dataInfo.shopId,
                        inputErrorMessage: '请输入店铺编码'
                    }).then(async ({ value }) => {
                        const res = await this.$http.cusmasterbindshopId({
                            cmId: dataInfo.cmId,
                            shopId: value
                        })
                        if (res.status == 200) {
                            this.$message({
                                message: "操作成功",
                                type: "success",
                            });
                            this.getDataList()
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    }).catch(() => {
                    });
                    break;
                case 15:
                    this.openFormDesign();
                    break;
                case 16:
                    this.actionDataActionType = actionData.actionType;
                    if (this.returnData.list.length <= 0) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    }
                    var dataInfoe = this.returnData.list[this.selectedDataIndex];
                    if (!dataInfoe) {
                        this.$message({
                            message: "请先选择您要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.statusSendData.cmId = dataInfoe['cmId']
                    this.statusSendData.cmRemark = dataInfoe['cmRemark'] //	备注
                    this.statusSendData.cmState = dataInfoe['cmState'] //	商品状态

                    this.statusFlag = true;
                    break;
                case 17:
                    this.actionDataActionType = actionData.actionType;
                    if (this.returnData.list.length <= 0) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    }
                    var dataInfoe = this.returnData.list[this.selectedDataIndex];
                    if (!dataInfoe) {
                        this.$message({
                            message: "请先选择您要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.statusSendData.cmId = dataInfoe['cmId']
                    this.statusSendData.cmRemark = dataInfoe['cmSustateRemark'] //	备注
                    this.statusSendData.cmState = dataInfoe['cmSustate'] //	商品状态

                    this.statusFlag = true;
                    break;
            }
        },
        invoiceClick(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    var dataInfoe = this.returnData.list[this.selectedDataIndex];
                    let params = this.invoiceObj
                    params.cmId = dataInfoe.cmId
                    const responseData = await this.$http.updateInvoiceInfo(params)
                    if (responseData.status == 200) {
                        this.$message.success(responseData.message);
                        this.invoiceFlag = false
                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                }
            })
        },
        // 导出客户资料数据
        exportMainInfo() {
            //清空时间
            this.getRequestData.start = "";
            this.getRequestData.end = "";
            window.location.href = this.requesUrl + `/gspCustomer/exportCusData${this.$common.getUrl(this.getRequestData)}&ormId=${String(this.ormId)}&menuType=lb`;
        },
        // 导出客户证照
        exportLicenceInfo() {
            window.location.href = this.requesUrl + `/gspCustomer/exportCusLicenceData${this.$common.getUrl(this.getRequestData)}&ormId=${String(this.ormId)}`;
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path);
            this.$refs["customDesign"].openBox(
                pathInfo.jurId,
                this.pageShowData,
                pathInfo.jurName
            );
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.getCusmaster(this.getRequestData);
            if (responseData.status == 200) {
                this.returnData.list = this.$common.getIndex(responseData.result.list)
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
                this.selectedDataIndex = 0;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async getMenuData() {
            const params = { codeClassify: 2 }
            const res = await this.$http.getQueryCodeClassify(params)
            if (res.status == 200) {
                this.menuList = res.result || []
            } else {
                this.menuList = []
            }
            this.activeMenu = "all"
            this.$set(this.getRequestData, 'codeType', '')
        },

        // 删除数据
        delDataAction() {
            if (!this.returnData.list[this.selectedDataIndex]) {
                this.$message({
                    message: "请先选择您要操作的数据",
                    type: "error",
                });
                return false;
            }
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.cmId],
                    };
                    let responseData = await this.$http.delCusmaster(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        // 更改状态数据
        setStatusDataAction(formName) {
            console.log(formName, 'formNameformNameformName');
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$http.setCusmasterStatus(this.statusSendData).then(res => {
                        if (res.status == 200) {
                            this.$refs[formName].resetFields()
                            this.statusFlag = false;
                            this.getDataList()
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    })
                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                }
            })
        },
        // 更改状态数据
        setStatusDataAction1(formName) {
            console.log('formNameformNameformName222222');
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$http.cusmasterModifySuState(this.statusSendData).then(res => {
                        console.log(res, 'resresresresresres');
                        if (res.status == 200) {
                            console.log(res, 'res1111111');
                            this.$refs[formName].resetFields()
                            this.statusFlag = false;
                            this.getDataList()
                        } else {
                            console.log(res, 'res2222');
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    })
                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                }
            })
        },
        // 拷贝数据
        copyDataAction() {
            if (!this.returnData.list[this.selectedDataIndex]) {
                this.$message({
                    message: "请先选择您要操作的数据",
                    type: "error",
                });
                return false;
            }
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            this.$confirm("确定要拷贝吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var senData = {
                        cmId: dataInfo.cmId,
                    };
                    let responseData = await this.$http.copyCusmaster(senData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "操作成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton();
            
        },
//结束时间改成最后时间
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();
        this.imgUrl = this.$store.getters.getConfig.imgUrl;
        this.ormId = sessionStorage.getItem('ormId')
        this.requesUrl = this.$store.getters.getConfig.requestUrl;
        this.isMenu = window.global_config.isLeftMenuBgm || false
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.page_content_center {
    display: flex;
    justify-content: space-between;
}

.left {
    flex-shrink: 0;
    overflow-y: auto;
    overflow-x: hidden;
    width: 150px;
}

.el-menu-vertical-demo {
    width: 150px;
    border-right: none;
}

.right {
    flex: 1;
    min-width: 0;
    width: calc(100% - 160px);
}

.right-full {
    width: 100%;
}

::v-deep .el-menu-item {
    height: 36px;
    line-height: 36px;
}
</style>